import getWatchAlertsStore from "../../../../stores/developer-store/watch-alerts-store";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";

const WatchAlertsForm = withLiteObserverAndTheme(() => {
  return (
    <Et3Button
      isEnabled={true}
      onClick={async () => {
        getWatchAlertsStore().getAlerts();
      }}
      size="LARGE"
      text="GET"
      type="GET"
    />
  );
});

export default WatchAlertsForm;
